// To add a failure condition: append to failureConditions — first match wins.
// To change what counts as success: edit requiredEvents.
//
// Known events reference:
//   intercom.flat-call   — panel dialling started
//   intercom.init-call   — call initialised
//   intercom.call        — call in progress
//   intercom.talking     — parties talking (or cancelled with data.reason)
//   intercom.call_stop   — call ended
//
// data.reason values on intercom.talking:
//   wrong_flat_number    — flat not found
//   ring_timeout         — no answer
//   cancel_cloud         — cloud call error
//   cancel_handset       — analogue handset error
export const CALL_ANALYSIS_RULES = {
  requiredEvents: [
    'intercom.flat-call',
    'intercom.init-call',
    'intercom.call',
    'intercom.talking',
  ],
  failureConditions: [
    {
      id: 'wrong_flat_number',
      label: 'wrong_flat_number',
      match: (log) => {
        return (
          log.event === 'intercom.talking' &&
          log.data?.reason === 'wrong_flat_number'
        )
      },
    },
  ],
}

// Returns { status, requiredEvents, matchedEvents, missingEvents, failureLabel }
// status: 'success' | 'failure' | 'pending'
export function analyzeTestCall({ logs, flatNum, callStartTime, testCallErr }) {
  const { requiredEvents, failureConditions } = CALL_ANALYSIS_RULES
  if (testCallErr) {
    return {
      status: 'failure',
      requiredEvents,
      matchedEvents: [],
      missingEvents: [],
      failureLabel: testCallErr,
    }
  }
  const relevantLogs = logs.filter((log) => {
    if (callStartTime && new Date(log.dateTime).getTime() < callStartTime)
      return false
    if (!requiredEvents.includes(log.event)) return false
    return String(log.data?.flat) === String(flatNum)
  })
  const failedCondition = failureConditions.find((condition) =>
    relevantLogs.some((log) => condition.match(log))
  )
  if (failedCondition) {
    return {
      status: 'failure',
      requiredEvents,
      matchedEvents: relevantLogs.map((l) => l.event),
      missingEvents: [],
      failureLabel: failedCondition.label,
    }
  }

  const matchedEvents = requiredEvents.filter((ev) =>
    relevantLogs.some((log) => log.event === ev)
  )
  const missingEvents = requiredEvents.filter(
    (ev) => !relevantLogs.some((log) => log.event === ev)
  )

  return {
    status: missingEvents.length === 0 ? 'success' : 'pending',
    requiredEvents,
    matchedEvents,
    missingEvents,
    failureLabel: null,
  }
}
